import React, { useState } from 'react';
import { parseBrazilianNumber } from '../../../utils/formatUtils';
import { FormField, ResultCard } from './shared';

const EquivalentRateCalculator = ({ onResultChange }: { onResultChange: (data: { label: string, value: string }[]) => void }) => {
  const [rate, setRate] = useState('12');
  const [fromPeriod, setFromPeriod] = useState('yearly');
  const [toPeriod, setToPeriod] = useState('monthly');
  const [resultState, setResultState] = useState<any>(null);

  const calculate = () => {
    const r = parseFloat(parseBrazilianNumber(rate)) / 100;
    if (!r) return;

    const periodDays = {
      daily: 1, weekly: 7, fortnightly: 15, monthly: 30,
      bimonthly: 60, quarterly: 90, semiannual: 180, yearly: 365
    };

    const fromDays = periodDays[fromPeriod as keyof typeof periodDays];
    const toDays = periodDays[toPeriod as keyof typeof periodDays];
    const equivalentRate = Math.pow(1 + r, toDays / fromDays) - 1;
    const effectiveAnnual = Math.pow(1 + r, 365 / fromDays) - 1;

    const res = {
      equivalentRate: (equivalentRate * 100).toFixed(4),
      effectiveAnnual: (effectiveAnnual * 100).toFixed(2),
      fromPeriod, toPeriod
    };

    setResultState(res);
    onResultChange([
      { label: 'Taxa Original', value: `${rate}%` },
      { label: 'Período De', value: res.fromPeriod },
      { label: 'Período Para', value: res.toPeriod },
      { label: 'Taxa Equivalente', value: `${res.equivalentRate}%` },
      { label: 'Efetiva Anual', value: `${res.effectiveAnnual}%` }
    ]);
  };

  return (
    <div className="space-y-8">
      <div className="bg-theme-result p-6 rounded-2xl border border-theme-border">
        <h2 className="text-xl font-bold text-theme-text mb-3">Taxa Equivalente</h2>
        <p className="text-theme-muted">Converta taxas entre períodos mantendo o mesmo rendimento efetivo.</p>
      </div>
      <div className="bg-theme-result p-8 rounded-3xl shadow-lg border border-theme-border">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <FormField label="Taxa (%)" value={rate} onChange={setRate} isNumeric required />
          <FormField label="De" value={fromPeriod} onChange={setFromPeriod} type="select" options={[
            { value: 'daily', label: 'Diário' }, { value: 'weekly', label: 'Semanal' }, { value: 'monthly', label: 'Mensal' }, { value: 'yearly', label: 'Anual' }
          ]} />
          <FormField label="Para" value={toPeriod} onChange={setToPeriod} type="select" options={[
            { value: 'daily', label: 'Diário' }, { value: 'weekly', label: 'Semanal' }, { value: 'monthly', label: 'Mensal' }, { value: 'yearly', label: 'Anual' }
          ]} />
        </div>
        <div className="flex justify-center mt-8">
          <button onClick={calculate} className="px-10 py-4 bg-accent-gradient text-white rounded-xl font-bold shadow-accent hover:scale-105 transition-all">Calcular</button>
        </div>
      </div>
      {resultState && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <ResultCard title="Taxa Equivalente" value={`${resultState.equivalentRate}%`} color="indigo" />
          <ResultCard title="Efetiva Anual" value={`${resultState.effectiveAnnual}%`} color="emerald" />
        </div>
      )}
    </div>
  );
};

export default EquivalentRateCalculator;
